var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrandlocal50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    fill: "#0ecb81",
    id: "svg_1",
    r: 23.27
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.57,12l-5.39,17.9s-0.69,2.75 0.6,4.36c1.28,1.61 3.33,2.21 5.04,2.21l11.7,0l1.62,-5l-8.92,0c-1.41,0 -1.96,-1.14 -1.58,-2.5c0.38,-1.35 0.99,-2.75 0.99,-2.75l11.1,0l-15.16,-14.22z",
    fill: "#ffffff",
    id: "svg_4",
    strokeWidth: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrandlocal50);
export default __webpack_public_path__ + "static/media/errandlocal50.13abe7bdd6a11d3bd2bdedfcb22a4c90.svg";
export { ForwardRef as ReactComponent };